<mat-dialog-content>
  <ng-template [ngIf]="isPublicError">
    <div class="json-formatter-row json-formatter-open" style="background-color: white">
      <span class="json-formatter-string">{{ asPublicError().msg }}</span>
    </div>
    <p></p>
  </ng-template>
  <div #causeDisplay style="background-color: white"></div>
</mat-dialog-content>